import React from 'react';
import {
  Box,
  VStack,
  Text,
  Icon,
  useColorModeValue,
  Container,
} from '@chakra-ui/react';
import { FaRocket, FaClock, FaStar } from 'react-icons/fa';

interface ComingSoonProps {
  title: string;
  description: string;
  icon?: React.ComponentType;
  features?: string[];
}

const ComingSoon: React.FC<ComingSoonProps> = ({ 
  title, 
  description, 
  icon: IconComponent = FaRocket,
  features = []
}) => {
  const bgGradient = useColorModeValue(
    'linear(to-br, blue.50, purple.50)',
    'linear(to-br, blue.900, purple.900)'
  );
  const textColor = useColorModeValue('gray.700', 'gray.200');
  const iconColor = useColorModeValue('blue.500', 'blue.300');
  const featureColor = useColorModeValue('gray.600', 'gray.400');

  return (
    <Container maxW="container.md" py={8}>
      <Box
        bgGradient={bgGradient}
        borderRadius="xl"
        p={8}
        textAlign="center"
        borderWidth="1px"
        borderColor={useColorModeValue('gray.200', 'gray.600')}
        shadow="lg"
      >
        <VStack spacing={6}>
          {/* アイコン */}
          <Box>
            <Icon 
              as={IconComponent} 
              boxSize={16} 
              color={iconColor}
              filter="drop-shadow(0 4px 8px rgba(0,0,0,0.1))"
            />
          </Box>

          {/* タイトル */}
          <VStack spacing={2}>
            <Text 
              fontSize="3xl" 
              fontWeight="bold" 
              color={textColor}
              textAlign="center"
            >
              {title}
            </Text>
            <Text 
              fontSize="lg" 
              color={textColor}
              textAlign="center"
              maxW="md"
              lineHeight="1.6"
            >
              {description}
            </Text>
          </VStack>

          {/* Coming Soon バッジ */}
          <Box
            bg={useColorModeValue('orange.100', 'orange.900')}
            color={useColorModeValue('orange.800', 'orange.200')}
            px={4}
            py={2}
            borderRadius="full"
            fontWeight="bold"
            fontSize="sm"
            border="2px solid"
            borderColor={useColorModeValue('orange.200', 'orange.700')}
          >
            <Icon as={FaClock} mr={2} />
            Coming Soon
          </Box>

          {/* 機能リスト */}
          {features.length > 0 && (
            <VStack spacing={2} mt={4}>
              <Text 
                fontSize="md" 
                fontWeight="semibold" 
                color={textColor}
              >
                予定している機能:
              </Text>
              <VStack spacing={1} align="start">
                {features.map((feature, index) => (
                  <Text 
                    key={index}
                    fontSize="sm" 
                    color={featureColor}
                    display="flex"
                    alignItems="center"
                  >
                    <Icon as={FaStar} mr={2} boxSize={3} color={iconColor} />
                    {feature}
                  </Text>
                ))}
              </VStack>
            </VStack>
          )}

          {/* フッターメッセージ */}
          <Text 
            fontSize="sm" 
            color={featureColor}
            fontStyle="italic"
            mt={4}
          >
            より良いサービス提供のため、現在開発中です
          </Text>
        </VStack>
      </Box>
    </Container>
  );
};

export default ComingSoon;